// Which 401 responses mean "the session expired, log out and sign in again".
//
// Not these, or a failed login loops forever (SPNS-506): the login/logout calls
// and anything that fails while the callback page is completing the login
// answer 401 on purpose, and the callback page shows its own error screen. If
// the interceptor logged out here, /login would send the user straight back to
// LUC, which returns to the callback, which fails again.
const CALLBACK_PATH = '/auth/callback';
const AUTH_ENDPOINTS = ['/awsluc/login', '/awsluc/logout'];

export const isSessionExpiredUnauthorized = (
  url,
  pathname = window.location.pathname,
) => {
  const lower = url?.toLowerCase() || '';
  if (!lower.includes('liveu.tv')) return false;
  if (AUTH_ENDPOINTS.some((endpoint) => lower.includes(endpoint))) return false;
  if (pathname.startsWith(CALLBACK_PATH)) return false;
  return true;
};
